import styled from 'styled-components';

export const Container = styled.div<{ $buttonTrigger: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${({ $buttonTrigger }) => ($buttonTrigger ? 'stretch' : 'center')};

  ${({ $buttonTrigger }) =>
    !$buttonTrigger &&
    `
      position: absolute;
      top: 7px;
      right: 16px;
      z-index: 1;
      height: 50px;
    `}

  @media ${({ theme }) => theme.queries.minTablet} {
    ${({ $buttonTrigger }) =>
      !$buttonTrigger &&
      `
        right: 24px;
      `}
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    ${({ $buttonTrigger }) =>
      !$buttonTrigger &&
      `
        top: 15px;
        right: 32px;
      `}
  }
`;
